import { motion } from "framer-motion";
import { useState } from "react";
import ScrollReveal from "./scroll-reveal";

const products = [
  {
    id: 1,
    name: "Executive Chair Pro",
    description: "Ergonomic design with premium leather finish",
    price: "₹45,000",
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600",
    category: "chairs",
  },
  {
    id: 2,
    name: "Modern Desk Elite",
    description: "Sleek design with integrated cable management",
    price: "₹32,000",
    image: "https://images.unsplash.com/photo-1549497538-303791108f95?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600",
    category: "desks",
  },
  {
    id: 3,
    name: "Storage Solution Max",
    description: "Modular storage with premium finishes",
    price: "₹28,500",
    image: "https://images.unsplash.com/photo-1588200908342-23b585c03e26?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600",
    category: "storage",
  },
  {
    id: 4,
    name: "Collaborative Station",
    description: "Perfect for team collaboration spaces",
    price: "₹52,000",
    image: "https://images.unsplash.com/photo-1565814329452-e1efa11c5b89?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600",
    category: "desks",
  },
  {
    id: 5,
    name: "Lounge Chair Luxury",
    description: "Comfort meets elegance in reception areas",
    price: "₹38,000",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600",
    category: "chairs",
  },
  {
    id: 6,
    name: "Height Adjustable Desk",
    description: "Health-focused adjustable workspace",
    price: "₹42,500",
    image: "https://images.unsplash.com/photo-1511300636408-a63a89df3482?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600",
    category: "desks",
  },
];

const filters = [
  { id: "all", name: "All Products" },
  { id: "chairs", name: "Chairs" },
  { id: "desks", name: "Desks" },
  { id: "storage", name: "Storage" },
  { id: "accessories", name: "Accessories" },
];

export default function ProductsSection() {
  const [activeFilter, setActiveFilter] = useState("all");

  const filteredProducts = activeFilter === "all" 
    ? products 
    : products.filter(product => product.category === activeFilter);

  return (
    <section id="products" className="py-20 bg-secondary dark:bg-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-playfair font-bold mb-4">
              Our Premium Collection
            </h2>
            <p className="text-xl text-neutral max-w-2xl mx-auto">
              Discover furniture that combines functionality with elegance
            </p>
          </div>
        </ScrollReveal>

        {/* Filter Options */}
        <ScrollReveal>
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {filters.map((filter) => (
              <motion.button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 hover-lift hover-cursor ${
                  activeFilter === filter.id
                    ? "bg-accent text-white"
                    : "bg-white dark:bg-gray-800 text-primary dark:text-white hover:bg-accent hover:text-white"
                }`}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {filter.name}
              </motion.button>
            ))}
          </div>
        </ScrollReveal>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product, index) => (
            <ScrollReveal key={product.id} delay={index * 0.1}>
              <motion.div
                className="product-card bg-white dark:bg-gray-800 rounded-2xl overflow-hidden shadow-lg hover-lift hover-cursor"
                whileHover={{ y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover product-image"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2">{product.name}</h3>
                  <p className="text-neutral mb-4">{product.description}</p>
                  <div className="flex justify-between items-center">
                    <span className="text-2xl font-bold text-accent">
                      {product.price}
                    </span>
                    <motion.button
                      className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-opacity-90 transition-all duration-300 hover-cursor"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      View Details
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
